import React, { useEffect } from "react";

/**
 * The "default" style: the plain "Winner processing" box the closing
 * seconds had before there were any shows. No draw and no winner - it
 * stays up while purchasing is closed and takes itself down the moment
 * the clock runs out, exactly as it always did.
 */
export default function WinnerProcessingBox({
  remainingSeconds,
  betCloseSeconds,
  closedLabel = "Purchasing",
  onFinished,
}) {
  const over = !(Number(remainingSeconds) > 0);

  useEffect(() => {
    if (over && typeof onFinished === "function") onFinished();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [over]);

  if (over) return null;

  return (
    <div
      className="rv-processing-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Winner processing"
      onClick={(e) => e.preventDefault()}
    >
      <div className="rv-processing-box" onClick={(e) => e.stopPropagation()}>
        <div className="rv-processing-title">Winner processing</div>
        <div className="rv-processing-sub">
          {closedLabel} is closed in the last {betCloseSeconds} seconds.
        </div>
        <div className="rv-processing-timer">
          Next round starts soon ({remainingSeconds}s)
        </div>
        <div className="rv-processing-wait">
          <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
            <circle
              cx="12"
              cy="12"
              r="9"
              fill="none"
              stroke="#667eea"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="42 56"
            >
              <animateTransform
                attributeName="transform"
                type="rotate"
                from="0 12 12"
                to="360 12 12"
                dur="0.9s"
                repeatCount="indefinite"
              />
            </circle>
          </svg>
          <span>Please wait...</span>
        </div>
      </div>
    </div>
  );
}
